import { createStore } from "zustand/vanilla";
import { useStoreWithEqualityFn } from "zustand/traditional";
import type { Team, Tenant } from "@repo/types";
import { teamRepo } from "@/repositories/teamRepo";
import { take } from "rxjs";
import { baseRepo } from "@/repositories/baseRepo";

export interface TenantState {
  tenant: Tenant | undefined;
  id: string;
  setTenant: (tenant: Tenant | null | undefined) => void;
  tenantTeams: Team[];
}

export const tenantStore = createStore<TenantState>()((set) => ({
  tenant: undefined,
  id: "",
  setTenant: (tenant: Tenant | null | undefined) => {
    if (!tenant) {
      set({ tenant: undefined, id: "" });
      return;
    }

    set({ tenant, id: tenant.id });
    teamRepo
      .list(tenant.id)
      .pipe(take(1))
      .subscribe((teams) => {
        set({ tenantTeams: teams });
      });
  },
  tenantTeams: [] as Team[],
}));

export function useTenantStore(): TenantState;

export function useTenantStore<T>(
  selector: (state: TenantState) => T,
  equals?: (a: T, b: T) => boolean
): T;

export function useTenantStore<T>(
  selector?: (state: TenantState) => T,
  equalityFn?: (a: T, b: T) => boolean
) {
  return useStoreWithEqualityFn(tenantStore, selector!, equalityFn);
}

baseRepo.getTenantId = () => tenantStore.getState()?.id || undefined;
